var _desc, _defs, _rect, _text, _text2, _rect2, _path, _text3, _text4, _rect3, _text5, _text6, _rect4, _text7, _text8, _rect5, _text9, _text0, _path2, _text1, _path3, _text10, _rect6, _text11, _text12, _text13, _path4, _text14, _rect7, _text15, _text16, _text17, _rect8, _text18, _text19, _text20, _path5, _path6, _rect9, _text21, _rect0, _path7, _text22, _text23, _rect1, _text24, _text25, _text26, _rect10, _text27, _text28, _text29, _rect11, _text30, _text31, _text32, _path8, _text33, _path9, _text34, _rect12, _text35, _text36, _text37, _path0, _rect13, _text38, _text39, _path1, _rect14, _text40, _text41, _text42, _rect15, _text43, _path10, _rect16, _text44, _path11, _rect17, _text45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateNetworkRequirements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 920,
    viewBox: "0 0 1440 920",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Certificate issuance network requirements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Comparison of HTTP-01 inbound validation, which requires public DNS and port 80 forwarding to the exact Nginx host, with DNS-01 validation, which uses outbound access to Route 53 and needs no inbound port forwarding.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow-blue",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#2563eb"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow-green",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#059669"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow-red",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#dc2626"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .title { font: 700 34px Inter, ui-sans-serif, system-ui, sans-serif; fill: #0f172a; }\n      .subtitle { font: 400 17px Inter, ui-sans-serif, system-ui, sans-serif; fill: #475569; }\n      .panel-title { font: 700 24px Inter, ui-sans-serif, system-ui, sans-serif; fill: #ffffff; }\n      .panel-subtitle { font: 500 15px Inter, ui-sans-serif, system-ui, sans-serif; fill: #dbeafe; }\n      .panel-subtitle-green { font: 500 15px Inter, ui-sans-serif, system-ui, sans-serif; fill: #d1fae5; }\n      .node-title { font: 700 16px Inter, ui-sans-serif, system-ui, sans-serif; fill: #0f172a; }\n      .node-text { font: 400 14px Inter, ui-sans-serif, system-ui, sans-serif; fill: #475569; }\n      .edge { font: 600 13px Inter, ui-sans-serif, system-ui, sans-serif; fill: #334155; }\n      .note-title { font: 700 17px Inter, ui-sans-serif, system-ui, sans-serif; fill: #0f172a; }\n      .note-text { font: 400 14px Inter, ui-sans-serif, system-ui, sans-serif; fill: #334155; }\n      .pill { font: 700 13px Inter, ui-sans-serif, system-ui, sans-serif; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 920,
    fill: "#f8fafc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 55,
    textAnchor: "middle",
    className: "title"
  }, "Certificate issuance network requirements")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 86,
    textAnchor: "middle",
    className: "subtitle"
  }, "The two Certbot tools prove domain control through different network paths")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 120,
    width: 650,
    height: 600,
    rx: 18,
    fill: "#ffffff",
    stroke: "#bfdbfe",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 120 H682 A18 18 0 0 1 700 138 V210 H50 V138 A18 18 0 0 1 68 120 Z",
    fill: "#1d4ed8"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 161,
    className: "panel-title"
  }, "issue_cert \xB7 HTTP-01")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 190,
    className: "panel-subtitle"
  }, "Inbound validation \xB7 public port 80 must reach the correct host")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 246,
    width: 150,
    height: 76,
    rx: 12,
    fill: "#eff6ff",
    stroke: "#93c5fd"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 277,
    textAnchor: "middle",
    className: "node-title"
  }, "Let\u2019s Encrypt")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 300,
    textAnchor: "middle",
    className: "node-text"
  }, "validation server")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 246,
    width: 150,
    height: 76,
    rx: 12,
    fill: "#eff6ff",
    stroke: "#93c5fd"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 277,
    textAnchor: "middle",
    className: "node-title"
  }, "Public DNS")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 300,
    textAnchor: "middle",
    className: "node-text"
  }, "domain \u2192 public IP")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 246,
    width: 150,
    height: 76,
    rx: 12,
    fill: "#eff6ff",
    stroke: "#93c5fd"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 277,
    textAnchor: "middle",
    className: "node-title"
  }, "Router / firewall")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 300,
    textAnchor: "middle",
    className: "node-text"
  }, "NAT forwards port 80")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230 284 H292",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3,
    markerEnd: "url(#arrow-blue)"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 261,
    y: 267,
    textAnchor: "middle",
    className: "edge"
  }, "HTTP")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450 284 H512",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3,
    markerEnd: "url(#arrow-blue)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 267,
    textAnchor: "middle",
    className: "edge"
  }, "public IP")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 390,
    width: 230,
    height: 104,
    rx: 14,
    fill: "#dbeafe",
    stroke: "#2563eb",
    strokeWidth: 2
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 423,
    textAnchor: "middle",
    className: "node-title"
  }, "Exact private host")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 447,
    textAnchor: "middle",
    className: "node-text"
  }, "Nginx + nginx-certbot-mcp")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 470,
    textAnchor: "middle",
    className: "node-text"
  }, "serves the challenge token")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M595 322 V360 Q595 375 580 375 H395 Q375 375 375 390",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3,
    markerEnd: "url(#arrow-blue)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 535,
    y: 360,
    textAnchor: "middle",
    className: "edge"
  }, "forward :80")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 558,
    width: 242,
    height: 104,
    rx: 14,
    fill: "#fff1f2",
    stroke: "#fda4af",
    strokeWidth: 2,
    strokeDasharray: "7 5"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 203,
    y: 591,
    textAnchor: "middle",
    className: "node-title"
  }, "Wrong box or VM")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 203,
    y: 615,
    textAnchor: "middle",
    className: "node-text"
  }, "Different private IP")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 203,
    y: 639,
    textAnchor: "middle",
    className: "node-text"
  }, "challenge never arrives")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 558,
    width: 242,
    height: 104,
    rx: 14,
    fill: "#fff1f2",
    stroke: "#fda4af",
    strokeWidth: 2,
    strokeDasharray: "7 5"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 591,
    textAnchor: "middle",
    className: "node-title"
  }, "Docker bridge container")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 615,
    textAnchor: "middle",
    className: "node-text"
  }, "Separate private network")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 639,
    textAnchor: "middle",
    className: "node-text"
  }, "needs explicit port publishing")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M595 322 V530 H203 V550",
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 2.5,
    strokeDasharray: "7 5",
    markerEnd: "url(#arrow-red)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M595 322 V530 H548 V550",
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 2.5,
    strokeDasharray: "7 5",
    markerEnd: "url(#arrow-red)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 510,
    width: 188,
    height: 29,
    rx: 14.5,
    fill: "#fff1f2",
    stroke: "#fecdd3"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 403,
    y: 530,
    textAnchor: "middle",
    className: "pill",
    fill: "#be123c"
  }, "NOT TARGETED BY NAT")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 120,
    width: 650,
    height: 600,
    rx: 18,
    fill: "#ffffff",
    stroke: "#a7f3d0",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M758 120 H1372 A18 18 0 0 1 1390 138 V210 H740 V138 A18 18 0 0 1 758 120 Z",
    fill: "#047857"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 161,
    className: "panel-title"
  }, "issue_wildcard_cert \xB7 DNS-01")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 768,
    y: 190,
    className: "panel-subtitle-green"
  }, "Outbound validation \xB7 no inbound port forwarding required")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 246,
    width: 180,
    height: 90,
    rx: 12,
    fill: "#ecfdf5",
    stroke: "#6ee7b7"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 278,
    textAnchor: "middle",
    className: "node-title"
  }, "MCP host")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 302,
    textAnchor: "middle",
    className: "node-text"
  }, "physical, VM, or Docker")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 323,
    textAnchor: "middle",
    className: "node-text"
  }, "sandbox")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 246,
    width: 170,
    height: 90,
    rx: 12,
    fill: "#ecfdf5",
    stroke: "#6ee7b7"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1085,
    y: 278,
    textAnchor: "middle",
    className: "node-title"
  }, "AWS Route 53")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 1085,
    y: 302,
    textAnchor: "middle",
    className: "node-text"
  }, "DNS API creates")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 1085,
    y: 323,
    textAnchor: "middle",
    className: "node-text"
  }, "TXT challenge record")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 246,
    width: 140,
    height: 90,
    rx: 12,
    fill: "#ecfdf5",
    stroke: "#6ee7b7"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1280,
    y: 278,
    textAnchor: "middle",
    className: "node-title"
  }, "Public DNS")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 1280,
    y: 302,
    textAnchor: "middle",
    className: "node-text"
  }, "_acme-challenge")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 1280,
    y: 323,
    textAnchor: "middle",
    className: "node-text"
  }, "TXT record")), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M960 291 H992",
    fill: "none",
    stroke: "#059669",
    strokeWidth: 3,
    markerEnd: "url(#arrow-green)"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 270,
    textAnchor: "middle",
    className: "edge"
  }, "HTTPS")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1170 291 H1202",
    fill: "none",
    stroke: "#059669",
    strokeWidth: 3,
    markerEnd: "url(#arrow-green)"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1186,
    y: 270,
    textAnchor: "middle",
    className: "edge"
  }, "TXT")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 965,
    y: 407,
    width: 230,
    height: 104,
    rx: 14,
    fill: "#d1fae5",
    stroke: "#059669",
    strokeWidth: 2
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1080,
    y: 440,
    textAnchor: "middle",
    className: "node-title"
  }, "Let\u2019s Encrypt")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 1080,
    y: 464,
    textAnchor: "middle",
    className: "node-text"
  }, "looks up the TXT record")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 1080,
    y: 488,
    textAnchor: "middle",
    className: "node-text"
  }, "through public DNS")), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1280 336 V375 Q1280 390 1265 390 H1100 Q1080 390 1080 407",
    fill: "none",
    stroke: "#059669",
    strokeWidth: 3,
    markerEnd: "url(#arrow-green)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 567,
    width: 500,
    height: 76,
    rx: 14,
    fill: "#f0fdf4",
    stroke: "#86efac"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 1065,
    y: 596,
    textAnchor: "middle",
    className: "node-title"
  }, "Works from any network with outbound access")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1065,
    y: 620,
    textAnchor: "middle",
    className: "node-text"
  }, "No public listener \xB7 no NAT rule \xB7 no fixed private IP")), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M870 336 V558",
    fill: "none",
    stroke: "#059669",
    strokeWidth: 2.5,
    strokeDasharray: "7 5",
    markerEnd: "url(#arrow-green)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 752,
    width: 1340,
    height: 130,
    rx: 18,
    fill: "#fff7ed",
    stroke: "#fdba74",
    strokeWidth: 2
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 788,
    className: "note-title"
  }, "Separate requirement: serving the site after certificate issuance")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 818,
    className: "note-text"
  }, "For the website to be reachable: DNS A/AAAA \u2192 public IP \u2192 Nginx. Behind NAT, forward ports 80/443 to its host.")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 846,
    className: "note-text"
  }, "This is required for HTTP-01 validation, but it is not required merely to obtain a certificate through DNS-01.")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 785,
    width: 105,
    height: 42,
    rx: 10,
    fill: "#ffedd5",
    stroke: "#fb923c"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 1047,
    y: 811,
    textAnchor: "middle",
    className: "node-title"
  }, "A / AAAA")), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1108 806 H1158",
    fill: "none",
    stroke: "#ea580c",
    strokeWidth: 3,
    markerEnd: "url(#arrow-red)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1168,
    y: 785,
    width: 95,
    height: 42,
    rx: 10,
    fill: "#ffedd5",
    stroke: "#fb923c"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 1215,
    y: 811,
    textAnchor: "middle",
    className: "node-title"
  }, "Public IP")), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1271 806 H1306",
    fill: "none",
    stroke: "#ea580c",
    strokeWidth: 3,
    markerEnd: "url(#arrow-red)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1316,
    y: 785,
    width: 55,
    height: 42,
    rx: 10,
    fill: "#ffedd5",
    stroke: "#fb923c"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 1343,
    y: 811,
    textAnchor: "middle",
    className: "node-title"
  }, "Nginx")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateNetworkRequirements);
export default __webpack_public_path__ + "static/media/certificate-network-requirements.e95b9cec8ba859b2d78e6ceff31af3a3.svg";
export { ForwardRef as ReactComponent };